$(document).on("click", "a[href='#']", function (e) {
  e.preventDefault();
  document.querySelector('.custom_price_landing_page').scrollIntoView({
    behavior: 'smooth'
  })
});


$(document).on("click", ".custom_single_ajax_js", function (e) {
e.preventDefault(); 
var this_element =  jQuery(this);
var id = jQuery(this).attr('variant_id');
var dataType = [];
this_element.addClass('loading_hk');
var quantity = 1;
var data = {}; 
data['id'] = id;
data['quantity'] = quantity;
//console.log(data);
dataType.push(data);
  const newData = {
items : [...dataType]
}
jQuery.ajax({
type: 'POST',
url: '/cart/add.js',
data:newData,
  dataType: 'json', 
 success: function (data) { 
setTimeout(function() {
this_element.removeClass('loading_hk'); 
}, 500);
 } 
 });
});